export default __webpack_public_path__ + "static/media/success_icon.3ec42d86.svg";